export const config = {
  services: {
    api: 'https://api.backstage.taste.xela.co',
    apiContent: 'https://api.live.xela.co/v1'
  },
};

export default config;
